import axios from "axios";

axios.defaults.withCredentials = true;

export const login = (accountInfo: object) => {
    return axios
        .post(`${process.env.REACT_APP_API_HOST}/auth/login`, accountInfo)
        .then((response) => Promise.resolve(response.data))
        .catch((error) => Promise.reject(error));
};

export const getLoginUser = () => {
    return axios
        .get(`${process.env.REACT_APP_API_HOST}/auth/me`)
        .then((response) => Promise.resolve(response.data))
        .catch((error) => Promise.reject(error));
};
